import { render, staticRenderFns } from "./HiddenInput.vue?vue&type=template&id=671ad5c5&scoped=true"
import script from "./HiddenInput.vue?vue&type=script&lang=js"
export * from "./HiddenInput.vue?vue&type=script&lang=js"
import style0 from "./HiddenInput.vue?vue&type=style&index=0&id=671ad5c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ad5c5",
  null
  
)

export default component.exports